export default __webpack_public_path__ + "static/media/details.419a6758.png";